import { pattern, custom } from '@carboledger/ui';
import { REGEX } from '@/config/regex.constants';
import {
  referenceIdNumberRule,
  positiveNumberRule,
  percentageRule,
  allocationPreferenceRule,
} from '@/lib/validation';
import { getTranslation } from '@/lib/utils/i18n';

// Rules for <ShipmentForm>. `required` is declared on each <Field>, so these cover.
export const shipmentValidation = {
  // Format only — the server owns uniqueness of the joined id.
  idPrefix: [
    pattern(REGEX.SHIPMENT_ID_PREFIX, getTranslation('INCOMING_SHIPMENTS_INVALID_ID_PREFIX')),
  ],
  idNumber: referenceIdNumberRule,

  shipmentQuantity: positiveNumberRule,

  allocationPreference: allocationPreferenceRule,

  density: positiveNumberRule,

  // The server rejects a density with no tracking unit, so the form says so first.
  trackingUnit: [
    custom(
      (value, values) => Boolean(value) || !values.trackingDensity,
      getTranslation('INCOMING_SHIPMENTS_TRACKING_UNIT_REQUIRED'),
    ),
  ],

  trackingDensity: positiveNumberRule,

  trackingDensityRequired: [
    ...positiveNumberRule,
    custom(Boolean, getTranslation('INCOMING_SHIPMENTS_TRACKING_DENSITY_REQUIRED')),
  ],
  ghgEmissions: positiveNumberRule,
  // A percentage, so it is capped at 100 as well as floored at 0.
  ghgEmissionSavings: percentageRule,

  // Both are YYYY-MM-DD date-input values, so a string compare is the date compare.
  dateOfDischarge: [
    custom(
      (value, values) =>
        !value || !values.dateOfDispatch || String(value) >= String(values.dateOfDispatch),
      getTranslation('INCOMING_SHIPMENTS_DISCHARGE_BEFORE_DISPATCH'),
    ),
  ],
};
